var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',[_c('b-breadcrumb-item',{attrs:{"text":'Profile'}})],1),_c('ProfileForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }